<template>
  <div class="relative flex justify-center items-center min-h-24">
    <saving-overlay
      opacity="40"
      v-if="paymentPending || !buttonLoaded"
    ></saving-overlay>
    <div class="z-1 pt-3">
      <div id="paypal_button" class="text-center"></div>
      <span class="help danger" v-if="error" v-text="error"></span>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { handleAxiosError } from "@/boot/functions";

// Hack to reduce lib size
// See https://github.com/braintree/braintree-web/issues/452
// import {
//   client as braintreeClient,
//   paypalCheckout as braintreePaypalCheckout,
// } from "braintree-web";
import braintreeClient from "braintree-web/client";
import braintreePaypalCheckout from "braintree-web/paypal-checkout";

import { loadScript } from "@braintree/asset-loader";

export default {
  props: ["config", "i18n"],
  data: () => {
    return {
      error: null,
      paymentPending: false,
      buttonLoaded: false,
      paypalCheckout: null,
      chargeUrl: null,
    };
  },
  computed: {
    locale() {
      return this.$route.params.locale;
    },
  },
  mounted() {
    this.loadButton();
    this.loadBraintree();
  },
  methods: {
    loadBraintree() {
      this.paypalCheckout = axios
        .post(this.config.createClientToken)
        .then(({ data }) => {
          this.chargeUrl = data.charge_url;
          return data.client_token;
        })
        .then(this.createCheckout)
        .catch((err) => {
          this.error = err;
          console.error(err);
          throw err;
        });
    },
    createCheckout(client_token) {
      return new Promise((resolve, reject) => {
        braintreeClient.create(
          {
            authorization: client_token,
            locale: this.locale,
          },
          (err, client) => {
            if (err) {
              reject("Could not create client: " + err);
              return;
            }

            // Create a PayPal Checkout component.
            braintreePaypalCheckout.create(
              {
                client: client,
              },
              (err, checkout) => {
                if (err) {
                  reject("Could not create PayPal Checkout: " + err);
                  return;
                }

                resolve(checkout);
              }
            );
          }
        );
      });
    },
    loadButton() {
      loadScript({
        src: "https://www.paypalobjects.com/api/checkout.min.js",
        id: "paypalobjects.com-checkout.min.js",
        dataAttributes: {
          "log-level": "warn",
        },
      })
        .then(() => {
          // eslint-disable-next-line no-undef
          return paypal.Button.render(
            {
              env: this.config.env,
              payment: this.createPayment,
              onAuthorize: this.tokenizePayment,
              onCancel: this.cancelPayment,
              onError: this.paymentError,
            },
            "#paypal_button"
          );
        })
        .then(() => {
          this.buttonLoaded = true;
        })
        .catch((err) => {
          this.error = err;
          console.error(err);
          throw err;
        });
    },
    createPayment() {
      this.paymentPending = true;
      return this.paypalCheckout.then((checkout) => {
        return checkout.createPayment({
          // Your PayPal options here. For available options, see
          // http://braintree.github.io/braintree-web/current/PayPalCheckout.html#createPayment
          flow: "checkout", // Required
          amount: this.config.amount, // Required
          billingAgreementDescription: this.config.subject,
          currency: "EUR", // Required
          enableShippingAddress: false,
          locale: this.locale,
          landingPageType: "login",
        });
      });
    },
    // eslint-disable-next-line no-unused-vars
    tokenizePayment(data, actions) {
      return this.paypalCheckout.then((checkout) => {
        return checkout.tokenizePayment(data, (err, payload) => {
          if (err) {
            this.error = err;
            console.error(err);
          }
          this.charge(payload.nonce);
        });
      });
    },
    charge(nonce) {
      return axios
        .post(this.chargeUrl, { nonce })
        .then(() => {
          this.$emit("payment-success", "paypal");
        })
        .catch((err) => {
          handleAxiosError(err);
          this.error = err;
          console.error(err);
        });
    },
    cancelPayment() {
      //console.log('checkout.js payment cancelled', JSON.stringify(data, 0, 2));
      this.paymentPending = false;
      this.error = "Payment cancelled";
    },
    paymentError(err) {
      //console.error('checkout.js error', err);
      this.paymentPending = false;
      this.error = err;
    },
  },
};
</script>
